<template>
  <div>
    <div class="entry-float-header">
      <span  v-html="$root.t('entry:sidebar:chlit')"></span>
    </div>

    <div>
        <div class="entry-float-title">
            <a 
                :href="chlit" 
                v-html="$root.t($route.params.view=='Person'?'entry:sidebar:chlit:person':'entry:sidebar:chlit:title')" 
                target="_blank"
                class="decorated"
            ></a>
            <a v-on:click="vvactive = !vvactive" class="info" :class="{'info-active': vvactive}">?</a>

        </div>
        <transition name="entry-block">
            <div class="entry-float-sidebar-results-multiline" v-if="vvactive == true">
                <span v-html="$root.t('entry:sidebar:literaturschweiz:info')"></span>
            </div>
        </transition>
    </div>




    <div class="entry-float-header">
      <span  v-html="$root.t('entry:sidebar:swissbib:divider')"></span>
    </div>
    <div>
        <div class="entry-float-title">
            <a 
                :href="`https://swisscovery.slsp.ch/discovery/search?query=any,contains,${term}&tab=41SLSP_NETWORK&search_scope=DN_and_CI&vid=41SLSP_NETWORK:VU1_UNION&offset=0`" 
                v-html="$root.t($route.params.view=='Person'?'entry:sidebar:swissbib:person':'entry:sidebar:swissbib:title')" 
                target="_blank"
                class="decorated"
            ></a>
            <a v-on:click="sbactive = !sbactive" class="info" :class="{'info-active': sbactive}">?</a>

        </div>
        <transition name="entry-block">
            <div class="entry-float-sidebar-results-multiline" v-if="sbactive == true">
                <span v-html="$root.t('entry:sidebar:swissbib:info')"></span>
            </div>
        </transition>
    </div>
  </div>
</template>


<script>

export default {
  name: 'Literaturschweiz',
  props: ['term'],
  computed: {
    chlit() {
      return this.$route.params.view == 'Person' 
        ? `https://www.literaturschweiz.ch/literaturlexikon?type=authors&q=${this.term}`
        : `https://www.literaturschweiz.ch/literaturlexikon?type=works&q=${this.term}`;
    }
  },
  data() {
    return {
      vvactive: false,
      sbactive: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.entry-float-sidebar-results {
    margin-bottom: $padding;
    @include smallfont();
    

    & > a {
        padding-bottom: $padding / 2;
        display: block;
        margin-bottom: $padding / 2;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    p {
        margin: 0;
        padding: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-top: 0;
    //    margin-bottom: $padding;
        @include smallfont();
    }
    &-loader {
        height: 4em; 
        text-align: center;
        
        @include smallfont();
        &-loading {
            background-image: url('~@/assets/images/spinner.svg');
            background-position: center center;
            background-repeat: no-repeat;
            background-size: $padding * 2 $padding * 2;
        }
        
        
    }
}


</style>
